export type StoredPostContext = 'discussion' | 'poll';

export function resolveStoredPostContext(input: {
  type?: string | null;
}): StoredPostContext {
  if (input.type === 'poll') {
    return 'poll';
  }
  return 'discussion';
}

export function isPollPost(input: {
  type?: string | null;
  context?: string | null;
  pollData?: unknown;
}): boolean {
  return input.type === 'poll';
}
